
import * as types from "../../constants/ActionTypes.js"

export const isOgcToIcc = () => {
  return {
    type: types.IS_OGC_TO_ICC
  }
};